import camelCase from "lodash/camelCase";
import isArray from "lodash/isArray";
import isObject from "lodash/isObject";
import transform from "lodash/transform";

const applyToKeys = (stringFunction) => (obj) => {
  const dictWithNewKeys = transform(obj, (acc, value, key, target) => {
    const newKey = isArray(target) ? key : stringFunction(key);
    acc[newKey] = isObject(value) ? applyToKeys(stringFunction)(value) : value;
  });

  return dictWithNewKeys;
};

export const camelize = applyToKeys(camelCase);
